module.exports = __webpack_public_path__ + "static/16-f9e7d3c2be284f1cbeeea21ead57a347.jpg";